module.exports = __webpack_public_path__ + "static/media/logo-sanpablo.07b08657.png";